import {
    httpStoreProjectClinicalPresentations,
    HttpStoreProjectClinicalPresentationsPayload
} from '@/features/projects/http/projects.http'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useStoreClinicalPresentations = (
    urlParams: {projectId: string},
    options?: UseMutationOptions<unknown, AxiosError<ErrorResponseData>, HttpStoreProjectClinicalPresentationsPayload>
) => {
    return useMutation({
        ...options,
        mutationFn: (payload: HttpStoreProjectClinicalPresentationsPayload) =>
            httpStoreProjectClinicalPresentations({urlParams, payload})
    })
}
